export default __webpack_public_path__ + "static/media/loader.unsure.bg.54e47aef.svg";